import React, { FocusEventHandler } from "react"

export function formGroup<TProps extends { onBlur?: FocusEventHandler, onFocus?: FocusEventHandler, value?: any }>(Component: React.ComponentType<TProps>) {

    return class Inner extends React.Component<TProps & { additionalContent?: React.ReactNode }, { focused: boolean }>{
        constructor(props: TProps) {
            super(props);
            this.state = { focused: false };
        }
        private onBlur = () => this.setState({ focused: false });
        private onFocus = () => this.setState({ focused: true });
        render() {
            const { ...props } = this.props;
            return <div
                className={"mb-3" + (this.state.focused || this.props.value?.toString().length ? " focused" : "")}
            >
                <Component {...props}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    className={"form-control" + ((props as any).className ? ` ${(props as any).className}` : "")}
                />
                {props.additionalContent}
            </div>
        }
    }
}